import { render, staticRenderFns } from "./ImportElec.vue?vue&type=template&id=7f41fae4&scoped=true&"
var script = {}
import style0 from "./ImportElec.vue?vue&type=style&index=0&id=7f41fae4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f41fae4",
  null
  
)

export default component.exports